"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
exports.__esModule = true;
exports.default = void 0;
var _core = require("@uppy/core");
var _statusBar = _interopRequireDefault(require("@uppy/status-bar"));
var _informer = _interopRequireDefault(require("@uppy/informer"));
var _thumbnailGenerator = _interopRequireDefault(require("@uppy/thumbnail-generator"));
var _findAllDOMElements = _interopRequireDefault(require("@uppy/utils/lib/findAllDOMElements"));
var _toArray = _interopRequireDefault(require("@uppy/utils/lib/toArray"));
var _getDroppedFiles = _interopRequireDefault(require("@uppy/utils/lib/getDroppedFiles"));
var _providerViews = require("@uppy/provider-views");
var _nonSecure = require("nanoid/non-secure");
var _memoizeOne = _interopRequireDefault(require("memoize-one"));
var trapFocus = _interopRequireWildcard(require("./utils/trapFocus.js"));
var _createSuperFocus = _interopRequireDefault(require("./utils/createSuperFocus.js"));
var _Dashboard = _interopRequireDefault(require("./components/Dashboard.js"));
var _locale = _interopRequireDefault(require("./locale.js"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id = 0;
function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
var packageJson = {
  "version": "3.9.1"
};
var memoize = _memoizeOne.default.default || _memoizeOne.default;
var TAB_KEY = 9;
var ESC_KEY = 27;
function createPromise() {
  var o = {};
  o.promise = new Promise(function (resolve, reject) {
    o.resolve = resolve;
    o.reject = reject;
  });
  return o;
}
// set default options, must be kept in sync with packages/@uppy/react/src/DashboardModal.js
var defaultOptions = {
  target: 'body',
  metaFields: [],
  inline: false,
  width: 750,
  height: 550,
  thumbnailWidth: 280,
  thumbnailType: 'image/jpeg',
  waitForThumbnailsBeforeUpload: false,
  defaultPickerIcon: _providerViews.defaultPickerIcon,
  showLinkToFileUploadResult: false,
  showProgressDetails: false,
  hideUploadButton: false,
  hideCancelButton: false,
  hideRetryButton: false,
  hidePauseResumeButton: false,
  hideProgressAfterFinish: false,
  note: null,
  closeModalOnClickOutside: false,
  closeAfterFinish: false,
  singleFileFullScreen: true,
  disableStatusBar: false,
  disableInformer: false,
  disableThumbnailGenerator: false,
  disablePageScrollWhenModalOpen: true,
  animateOpenClose: true,
  fileManagerSelectionType: 'files',
  proudlyDisplayPoweredByUppy: true,
  showSelectedFiles: true,
  showRemoveButtonAfterComplete: false,
  browserBackButtonClose: false,
  showNativePhotoCameraButton: false,
  showNativeVideoCameraButton: false,
  theme: 'light',
  autoOpen: null,
  autoOpenFileEditor: false,
  disabled: false,
  disableLocalFiles: false,
  // Dynamic default options, they have to be defined in the constructor (because
  // they require access to the `this` keyword), but we still want them to
  // appear in the default options so TS knows they'll be defined.
  doneButtonHandler: undefined,
  onRequestCloseModal: null
};

/**
 * Dashboard UI with previews, metadata editing, tabs for various services and more
 */
var _disabledNodes = /*#__PURE__*/_classPrivateFieldLooseKey("disabledNodes");
var _generateLargeThumbnailIfSingleFile = /*#__PURE__*/_classPrivateFieldLooseKey("generateLargeThumbnailIfSingleFile");
var _openFileEditorWhenFilesAdded = /*#__PURE__*/_classPrivateFieldLooseKey("openFileEditorWhenFilesAdded");
var _attachRenderFunctionToTarget = /*#__PURE__*/_classPrivateFieldLooseKey("attachRenderFunctionToTarget");
var _isTargetSupported = /*#__PURE__*/_classPrivateFieldLooseKey("isTargetSupported");
var _getAcquirers = /*#__PURE__*/_classPrivateFieldLooseKey("getAcquirers");
var _getProgressIndicators = /*#__PURE__*/_classPrivateFieldLooseKey("getProgressIndicators");
var _getEditors = /*#__PURE__*/_classPrivateFieldLooseKey("getEditors");
var _addSpecifiedPluginsFromOptions = /*#__PURE__*/_classPrivateFieldLooseKey("addSpecifiedPluginsFromOptions");
var _autoDiscoverPlugins = /*#__PURE__*/_classPrivateFieldLooseKey("autoDiscoverPlugins");
var _addSupportedPluginIfNoTarget = /*#__PURE__*/_classPrivateFieldLooseKey("addSupportedPluginIfNoTarget");
var Dashboard = exports.default = /*#__PURE__*/function (_UIPlugin) {
  // Timeouts

  function Dashboard(uppy, _opts) {
    var _this;
    _classCallCheck(this, Dashboard);
    var _this$opts4, _this$opts4$onRequest;
    // support for the legacy `autoOpenFileEditor` option,
    // TODO: we can remove this code when we update the Uppy major version
    var autoOpen;
    if (!_opts) {
      autoOpen = null;
    } else if (_opts.autoOpen === undefined) {
      autoOpen = _opts.autoOpenFileEditor ? 'imageEditor' : null;
    } else {
      autoOpen = _opts.autoOpen;
    }
    _this = _callSuper(this, Dashboard, [uppy, _objectSpread(_objectSpread(_objectSpread({}, defaultOptions), _opts), {}, {
      autoOpen: autoOpen
    })]);
    Object.defineProperty(_this, _disabledNodes, {
      writable: true,
      value: void 0
    });
    _this.modalName = "uppy-Dashboard-".concat((0, _nonSecure.nanoid)());
    _this.superFocus = (0, _createSuperFocus.default)();
    _this.ifFocusedOnUppyRecently = false;
    _this.removeTarget = function (plugin) {
      var pluginState = _this.getPluginState();
      // filter out the one we want to remove
      var newTargets = pluginState.targets.filter(function (target) {
        return target.id !== plugin.id;
      });
      _this.setPluginState({
        targets: newTargets
      });
    };
    _this.addTarget = function (plugin) {
      var callerPluginId = plugin.id || plugin.constructor.name;
      var callerPluginName = plugin.title || callerPluginId;
      var callerPluginType = plugin.type;
      if (callerPluginType !== 'acquirer' && callerPluginType !== 'progressindicator' && callerPluginType !== 'editor') {
        var msg = 'Dashboard: can only be targeted by plugins of types: acquirer, progressindicator, editor';
        _this.uppy.log(msg, 'error');
        return null;
      }
      var target = {
        id: callerPluginId,
        name: callerPluginName,
        type: callerPluginType
      };
      var state = _this.getPluginState();
      var newTargets = state.targets.slice();
      newTargets.push(target);
      _this.setPluginState({
        targets: newTargets
      });
      return _this.el;
    };
    _this.hideAllPanels = function () {
      var _state$activePickerPa;
      var state = _this.getPluginState();
      var update = {
        activePickerPanel: undefined,
        showAddFilesPanel: false,
        activeOverlayType: null,
        fileCardFor: null,
        showFileEditor: false
      };
      if (state.activePickerPanel === update.activePickerPanel && state.showAddFilesPanel === update.showAddFilesPanel && state.showFileEditor === update.showFileEditor && state.activeOverlayType === update.activeOverlayType) {
        // avoid doing a state update if nothing changed
        return;
      }
      _this.setPluginState(update);
      _this.uppy.emit('dashboard:close-panel', (_state$activePickerPa = state.activePickerPanel) == null ? void 0 : _state$activePickerPa.id);
    };
    _this.showPanel = function (id) {
      var _this$getPluginState = _this.getPluginState(),
        targets = _this$getPluginState.targets;
      var activePickerPanel = targets.find(function (target) {
        return target.type === 'acquirer' && target.id === id;
      });
      _this.setPluginState({
        activePickerPanel: activePickerPanel,
        activeOverlayType: 'PickerPanel'
      });
      _this.uppy.emit('dashboard:show-panel', id);
    };
    _this.canEditFile = function (file) {
      var _this$getPluginState2 = _this.getPluginState(),
        targets = _this$getPluginState2.targets;
      var editors = _classPrivateFieldLooseBase(_this, _getEditors)[_getEditors](targets);
      return editors.some(function (target) {
        return _this.uppy.getPlugin(target.id).canEditFile(file);
      });
    };
    _this.openFileEditor = function (file) {
      var _this$getPluginState3 = _this.getPluginState(),
        targets = _this$getPluginState3.targets;
      var editors = _classPrivateFieldLooseBase(_this, _getEditors)[_getEditors](targets);
      _this.setPluginState({
        showFileEditor: true,
        fileCardFor: file.id || null,
        activeOverlayType: 'FileEditor'
      });
      editors.forEach(function (editor) {
        ;
        _this.uppy.getPlugin(editor.id).selectFile(file);
      });
    };
    _this.closeFileEditor = function () {
      var _this$getPluginState4 = _this.getPluginState(),
        metaFields = _this$getPluginState4.metaFields;
      var isMetaEditorEnabled = metaFields && metaFields.length > 0;
      if (isMetaEditorEnabled) {
        _this.setPluginState({
          showFileEditor: false,
          activeOverlayType: 'FileCard'
        });
      } else {
        _this.setPluginState({
          showFileEditor: false,
          fileCardFor: null,
          activeOverlayType: 'AddFiles'
        });
      }
    };
    _this.saveFileEditor = function () {
      var _this$getPluginState5 = _this.getPluginState(),
        targets = _this$getPluginState5.targets;
      var editors = _classPrivateFieldLooseBase(_this, _getEditors)[_getEditors](targets);
      editors.forEach(function (editor) {
        ;
        _this.uppy.getPlugin(editor.id).save();
      });
      _this.closeFileEditor();
    };
    _this.openModal = function () {
      var _createPromise = createPromise(),
        promise = _createPromise.promise,
        resolve = _createPromise.resolve;
      // save scroll position
      _this.savedScrollPosition = window.pageYOffset;
      // save active element, so we can restore focus when modal is closed
      _this.savedActiveElement = document.activeElement;
      if (_this.opts.disablePageScrollWhenModalOpen) {
        document.body.classList.add('uppy-Dashboard-isFixed');
      }
      if (_this.opts.animateOpenClose && _this.getPluginState().isClosing) {
        var _handler = function handler() {
          _this.setPluginState({
            isHidden: false
          });
          _this.el.removeEventListener('animationend', _handler, false);
          resolve();
        };
        _this.el.addEventListener('animationend', _handler, false);
      } else {
        _this.setPluginState({
          isHidden: false
        });
        resolve();
      }
      if (_this.opts.browserBackButtonClose) {
        _this.updateBrowserHistory();
      }

      // handle ESC and TAB keys in modal dialog
      document.addEventListener('keydown', _this.handleKeyDownInModal);
      _this.uppy.emit('dashboard:modal-open');
      return promise;
    };
    _this.closeModal = function (opts) {
      var _opts$manualClose;
      // Whether the modal is being closed by the user (`true`) or by other means (e.g. browser back button)
      var manualClose = (_opts$manualClose = opts == null ? void 0 : opts.manualClose) != null ? _opts$manualClose : true;
      var _this$getPluginState6 = _this.getPluginState(),
        isHidden = _this$getPluginState6.isHidden,
        isClosing = _this$getPluginState6.isClosing;
      if (isHidden || isClosing) {
        // short-circuit if animation is ongoing
        return undefined;
      }
      var _createPromise2 = createPromise(),
        promise = _createPromise2.promise,
        resolve = _createPromise2.resolve;
      if (_this.opts.disablePageScrollWhenModalOpen) {
        document.body.classList.remove('uppy-Dashboard-isFixed');
      }
      if (_this.opts.animateOpenClose) {
        _this.setPluginState({
          isClosing: true
        });
        var _handler2 = function handler() {
          _this.setPluginState({
            isHidden: true,
            isClosing: false
          });
          _this.superFocus.cancel();
          _this.savedActiveElement.focus();
          _this.el.removeEventListener('animationend', _handler2, false);
          resolve();
        };
        _this.el.addEventListener('animationend', _handler2, false);
      } else {
        _this.setPluginState({
          isHidden: true
        });
        _this.superFocus.cancel();
        _this.savedActiveElement.focus();
        resolve();
      }

      // handle ESC and TAB keys in modal dialog
      document.removeEventListener('keydown', _this.handleKeyDownInModal);
      if (manualClose) {
        if (_this.opts.browserBackButtonClose) {
          var _history$state;
          // Make sure that the latest entry in the history state is our modal name
          // eslint-disable-next-line no-restricted-globals
          if ((_history$state = history.state) != null && _history$state[_this.modalName]) {
            // Go back in history to clear out the entry we created (ultimately closing the modal)
            // eslint-disable-next-line no-restricted-globals
            history.back();
          }
        }
      }
      _this.uppy.emit('dashboard:modal-closed');
      return promise;
    };
    _this.isModalOpen = function () {
      return !_this.getPluginState().isHidden || false;
    };
    _this.requestCloseModal = function () {
      if (_this.opts.onRequestCloseModal) {
        return _this.opts.onRequestCloseModal();
      }
      return _this.closeModal();
    };
    _this.setDarkModeCapability = function (isDarkModeOn) {
      var _this$uppy$getState = _this.uppy.getState(),
        capabilities = _this$uppy$getState.capabilities;
      _this.uppy.setState({
        capabilities: _objectSpread(_objectSpread({}, capabilities), {}, {
          darkMode: isDarkModeOn
        })
      });
    };
    _this.handleSystemDarkModeChange = function (event) {
      var isDarkModeOnNow = event.matches;
      _this.uppy.log("[Dashboard] Dark mode is ".concat(isDarkModeOnNow ? 'on' : 'off'));
      _this.setDarkModeCapability(isDarkModeOnNow);
    };
    _this.toggleFileCard = function (show, fileID) {
      var file = _this.uppy.getFile(fileID);
      if (show) {
        _this.uppy.emit('dashboard:file-edit-start', file);
      } else {
        _this.uppy.emit('dashboard:file-edit-complete', file);
      }
      _this.setPluginState({
        fileCardFor: show ? fileID : null,
        activeOverlayType: show ? 'FileCard' : null
      });
    };
    _this.toggleAddFilesPanel = function (show) {
      _this.setPluginState({
        showAddFilesPanel: show,
        activeOverlayType: show ? 'AddFiles' : null
      });
    };
    _this.addFiles = function (files) {
      var descriptors = files.map(function (file) {
        return {
          source: _this.id,
          name: file.name,
          type: file.type,
          data: file,
          meta: {
            // path of the file relative to the ancestor directory the user selected.
            // e.g. 'docs/Old Prague/airbnb.pdf'
            relativePath: file.relativePath || file.webkitRelativePath || null
          }
        };
      });
      try {
        _this.uppy.addFiles(descriptors);
      } catch (err) {
        _this.uppy.log(err);
      }
    };
    // ___Why make insides of Dashboard invisible until first ResizeObserver event is emitted?
    //    ResizeOberserver doesn't emit the first resize event fast enough, users can see the jump from one .uppy-size-- to
    //    another (e.g. in Safari)
    // ___Why not apply visibility property to .uppy-Dashboard-inner?
    //    Because ideally, acc to specs, ResizeObserver should see invisible elements as of width 0. So even though applying
    //    invisibility to .uppy-Dashboard-inner works now, it may not work in the future.
    _this.startListeningToResize = function () {
      // Watch for Dashboard container (`.uppy-Dashboard-inner`) resize
      // and update containerWidth/containerHeight in plugin state accordingly.
      // Emits first event on initialization.
      _this.resizeObserver = new ResizeObserver(function (entries) {
        var uppyDashboardInnerEl = entries[0];
        var _uppyDashboardInnerEl = uppyDashboardInnerEl.contentRect,
          width = _uppyDashboardInnerEl.width,
          height = _uppyDashboardInnerEl.height;
        _this.setPluginState({
          containerWidth: width,
          containerHeight: height,
          areInsidesReadyToBeVisible: true
        });
      });
      _this.resizeObserver.observe(_this.el.querySelector('.uppy-Dashboard-inner'));

      // If ResizeObserver fails to emit an event telling us what size to use - default to the mobile view
      _this.makeDashboardInsidesVisibleAnywayTimeout = setTimeout(function () {
        var pluginState = _this.getPluginState();
        var isModalAndClosed = !_this.opts.inline && pluginState.isHidden;
        if (
        // We might want to enable this in the future

        // if ResizeObserver hasn't yet fired,
        !pluginState.areInsidesReadyToBeVisible &&
        // and it's not due to the modal being closed
        !isModalAndClosed) {
          _this.uppy.log('[Dashboard] resize event didn’t fire on time: defaulted to mobile layout', 'warning');
          _this.setPluginState({
            areInsidesReadyToBeVisible: true
          });
        }
      }, 1000);
    };
    _this.stopListeningToResize = function () {
      _this.resizeObserver.disconnect();
      clearTimeout(_this.makeDashboardInsidesVisibleAnywayTimeout);
    };
    // Records whether we have been interacting with uppy right now,
    // which is then used to determine whether state updates should trigger a refocusing.
    _this.recordIfFocusedOnUppyRecently = function (event) {
      if (_this.el.contains(event.target)) {
        _this.ifFocusedOnUppyRecently = true;
      } else {
        _this.ifFocusedOnUppyRecently = false;
        // ___Why run this.superFocus.cancel here when it already runs in superFocusOnEachUpdate?
        //    Because superFocus is debounced, when we move from Uppy to some other element on the page,
        //    previously run superFocus sometimes hits and moves focus back to Uppy.
        _this.superFocus.cancel();
      }
    };
    _this.disableInteractiveElements = function (disable) {
      var _classPrivateFieldLoo;
      var NODES_TO_DISABLE = ['a[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', '[role="button"]:not([disabled])'];
      var nodesToDisable = (_classPrivateFieldLoo = _classPrivateFieldLooseBase(_this, _disabledNodes)[_disabledNodes]) != null ? _classPrivateFieldLoo : (0, _toArray.default)(_this.el.querySelectorAll(NODES_TO_DISABLE)).filter(function (node) {
        return !node.classList.contains('uppy-Dashboard-close');
      });
      var _iterator = _createForOfIteratorHelper(nodesToDisable),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var node = _step.value;
          // Links can’t have `disabled` attr, so we use `aria-disabled` for a11y
          if (node.tagName === 'A') {
            node.setAttribute('aria-disabled', disable);
          } else {
            node.disabled = disable;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (disable) {
        _classPrivateFieldLooseBase(_this, _disabledNodes)[_disabledNodes] = nodesToDisable;
      } else {
        _classPrivateFieldLooseBase(_this, _disabledNodes)[_disabledNodes] = null;
      }
      _this.dashboardIsDisabled = disable;
    };
    _this.updateBrowserHistory = function () {
      var _history$state2;
      // Ensure history state does not already contain our modal name to avoid double-pushing
      // eslint-disable-next-line no-restricted-globals
      if (!((_history$state2 = history.state) != null && _history$state2[_this.modalName])) {
        // Push to history so that the page is not lost on browser back button press
        // eslint-disable-next-line no-restricted-globals
        history.pushState(_objectSpread(_objectSpread({}, history.state), {}, _defineProperty({}, _this.modalName, true)), '');
      }

      // Listen for back button presses
      window.addEventListener('popstate', _this.handlePopState, false);
    };
    _this.handlePopState = function (event) {
      var _event$state;
      // Close the modal if the history state no longer contains our modal name
      if (_this.isModalOpen() && (!event.state || !event.state[_this.modalName])) {
        _this.closeModal({
          manualClose: false
        });
      }

      // When the browser back button is pressed and uppy is now the latest entry
      // in the history but the modal is closed, fix the history by removing the
      // uppy history entry.
      // This occurs when another entry is added into the history state while the
      // modal is open, and then the modal gets manually closed.
      // Solves PR #575 (https://github.com/transloadit/uppy/pull/575)
      if (!_this.isModalOpen() && (_event$state = event.state) != null && _event$state[_this.modalName]) {
        // eslint-disable-next-line no-restricted-globals
        history.back();
      }
    };
    _this.handleKeyDownInModal = function (event) {
      // close modal on esc key press
      if (event.keyCode === ESC_KEY) _this.requestCloseModal();
      // trap focus on tab key press
      if (event.keyCode === TAB_KEY) trapFocus.forModal(event, _this.getPluginState().activeOverlayType, _this.el);
    };
    _this.handleClickOutside = function () {
      if (_this.opts.closeModalOnClickOutside) _this.requestCloseModal();
    };
    _this.handlePaste = function (event) {
      // Let any acquirer plugin (Url/Webcam/etc.) handle pastes to the root
      _this.uppy.iteratePlugins(function (plugin) {
        if (plugin.type === 'acquirer') {
          // Every Plugin with .type acquirer can define handleRootPaste(event)
          ;
          plugin.handleRootPaste == null || plugin.handleRootPaste(event);
        }
      });

      // Add all dropped files
      var files = (0, _toArray.default)(event.clipboardData.files);
      if (files.length > 0) {
        _this.uppy.log('[Dashboard] Files pasted');
        _this.addFiles(files);
      }
    };
    _this.handleInputChange = function (event) {
      event.preventDefault();
      var files = (0, _toArray.default)(event.target.files);
      if (files.length > 0) {
        _this.uppy.log('[Dashboard] Files selected through input');
        _this.addFiles(files);
      }
    };
    _this.handleDragOver = function (event) {
      var _this$opts$onDragOver, _this$opts;
      event.preventDefault();
      event.stopPropagation();

      // Check if some plugin can handle the datatransfer without files —
      // for instance, the Url plugin can import a url
      var canSomePluginHandleRootDrop = function canSomePluginHandleRootDrop() {
        var somePluginCanHandleRootDrop = true;
        _this.uppy.iteratePlugins(function (plugin) {
          if (plugin.canHandleRootDrop != null && plugin.canHandleRootDrop(event)) {
            somePluginCanHandleRootDrop = true;
          }
        });
        return somePluginCanHandleRootDrop;
      };

      // Check if the "type" of the datatransfer object includes files
      var doesEventHaveFiles = function doesEventHaveFiles() {
        var types = event.dataTransfer.types;
        return types.some(function (type) {
          return type === 'Files';
        });
      };

      // Deny drop, if no plugins can handle datatransfer, there are no files,
      // or when opts.disabled is set, or new uploads are not allowed
      var somePluginCanHandleRootDrop = canSomePluginHandleRootDrop();
      var hasFiles = doesEventHaveFiles();
      if (!somePluginCanHandleRootDrop && !hasFiles || _this.opts.disabled ||
      // opts.disableLocalFiles should only be taken into account if no plugins
      // can handle the datatransfer
      _this.opts.disableLocalFiles && (hasFiles || !somePluginCanHandleRootDrop) || !_this.uppy.getState().allowNewUpload) {
        event.dataTransfer.dropEffect = 'none'; // eslint-disable-line no-param-reassign
        clearTimeout(_this.removeDragOverClassTimeout);
        return;
      }

      // Add a small (+) icon on drop
      // (and prevent browsers from interpreting this as files being _moved_ into the
      // browser, https://github.com/transloadit/uppy/issues/1978).
      event.dataTransfer.dropEffect = 'copy'; // eslint-disable-line no-param-reassign

      clearTimeout(_this.removeDragOverClassTimeout);
      _this.setPluginState({
        isDraggingOver: true
      });
      (_this$opts$onDragOver = (_this$opts = _this.opts).onDragOver) == null || _this$opts$onDragOver.call(_this$opts, event);
    };
    _this.handleDragLeave = function (event) {
      var _this$opts$onDragLeav, _this$opts2;
      event.preventDefault();
      event.stopPropagation();
      clearTimeout(_this.removeDragOverClassTimeout);
      // Timeout against flickering, this solution is taken from drag-drop library.
      // Solution with 'pointer-events: none' didn't work across browsers.
      _this.removeDragOverClassTimeout = setTimeout(function () {
        _this.setPluginState({
          isDraggingOver: false
        });
      }, 50);
      (_this$opts$onDragLeav = (_this$opts2 = _this.opts).onDragLeave) == null || _this$opts$onDragLeav.call(_this$opts2, event);
    };
    _this.handleDrop = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
        var _this$opts$onDrop, _this$opts3, executedDropErrorOnce, logDropError, files;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              event.preventDefault();
              event.stopPropagation();
              clearTimeout(_this.removeDragOverClassTimeout);
              _this.setPluginState({
                isDraggingOver: false
              });

              // Let any acquirer plugin (Url/Webcam/etc.) handle drops to the root
              _this.uppy.iteratePlugins(function (plugin) {
                if (plugin.type === 'acquirer') {
                  // Every Plugin with .type acquirer can define handleRootDrop(event)
                  ;
                  plugin.handleRootDrop == null || plugin.handleRootDrop(event);
                }
              });

              // Add all dropped files
              executedDropErrorOnce = false;
              logDropError = function logDropError(error) {
                _this.uppy.log(error, 'error');

                // In practice all drop errors are most likely the same,
                // so let's just show one to avoid overwhelming the user
                if (!executedDropErrorOnce) {
                  _this.uppy.info(error.message, 'error');
                  executedDropErrorOnce = true;
                }
              };
              _this.uppy.log('[Dashboard] Processing dropped files');

              // Add all dropped files
              _context.n = 1;
              return (0, _getDroppedFiles.default)(event.dataTransfer, {
                logDropError: logDropError
              });
            case 1:
              files = _context.v;
              if (files.length > 0) {
                _this.uppy.log('[Dashboard] Files dropped');
                _this.addFiles(files);
              }
              (_this$opts$onDrop = (_this$opts3 = _this.opts).onDrop) == null || _this$opts$onDrop.call(_this$opts3, event);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    _this.handleRequestThumbnail = function (file) {
      if (!_this.opts.waitForThumbnailsBeforeUpload) {
        _this.uppy.emit('thumbnail:request', file);
      }
    };
    /**
     * We cancel thumbnail requests when a file item component unmounts to avoid
     * clogging up the queue when the user scrolls past many elements.
     */
    _this.handleCancelThumbnail = function (file) {
      if (!_this.opts.waitForThumbnailsBeforeUpload) {
        _this.uppy.emit('thumbnail:cancel', file);
      }
    };
    _this.handleKeyDownInInline = function (event) {
      // Trap focus on tab key press.
      if (event.keyCode === TAB_KEY) trapFocus.forInline(event, _this.getPluginState().activeOverlayType, _this.el);
    };
    // ___Why do we listen to the 'paste' event on a document instead of onPaste={props.handlePaste} prop,
    //    or this.el.addEventListener('paste')?
    //    Because (at least) Chrome doesn't handle paste if focus is on some button, e.g. 'My Device'.
    //    => Therefore, the best option is to listen to all 'paste' events, and only react to them when we are focused on our
    //       particular Uppy instance.
    // ___Why do we still need onPaste={props.handlePaste} for the DashboardUi?
    //    Because if we click on the 'Drop files here' caption e.g., `document.activeElement` will be 'body'. Which means our
    //    standard determination of whether we're pasting into our Uppy instance won't work.
    //    => Therefore, we need a traditional onPaste={props.handlePaste} handler too.
    _this.handlePasteOnBody = function (event) {
      var isFocusInOverlay = _this.el.contains(document.activeElement);
      if (isFocusInOverlay) {
        _this.handlePaste(event);
      }
    };
    _this.handleComplete = function (_ref) {
      var failed = _ref.failed;
      if (_this.opts.closeAfterFinish && !(failed != null && failed.length)) {
        // All uploads are done
        _this.requestCloseModal();
      }
    };
    _this.handleCancelRestore = function () {
      _this.uppy.emit('restore-canceled');
    };
    Object.defineProperty(_this, _generateLargeThumbnailIfSingleFile, {
      writable: true,
      value: function value() {
        if (_this.opts.disableThumbnailGenerator) {
          return;
        }
        var LARGE_THUMBNAIL = 600;
        var files = _this.uppy.getFiles();
        if (files.length === 1) {
          var thumbnailGenerator = _this.uppy.getPlugin("".concat(_this.id, ":ThumbnailGenerator"));
          thumbnailGenerator == null || thumbnailGenerator.setOptions({
            thumbnailWidth: LARGE_THUMBNAIL
          });
          var fileForThumbnail = _objectSpread(_objectSpread({}, files[0]), {}, {
            preview: undefined
          });
          thumbnailGenerator == null || thumbnailGenerator.requestThumbnail(fileForThumbnail).then(function () {
            thumbnailGenerator == null || thumbnailGenerator.setOptions({
              thumbnailWidth: _this.opts.thumbnailWidth
            });
          });
        }
      }
    });
    Object.defineProperty(_this, _openFileEditorWhenFilesAdded, {
      writable: true,
      value: function value(files) {
        var firstFile = files[0];
        var _this$getPluginState7 = _this.getPluginState(),
          metaFields = _this$getPluginState7.metaFields;
        var isMetaEditorEnabled = metaFields && metaFields.length > 0;
        var isImageEditorEnabled = _this.canEditFile(firstFile);
        if (isMetaEditorEnabled && _this.opts.autoOpen === 'metaEditor') {
          _this.toggleFileCard(true, firstFile.id);
        } else if (isImageEditorEnabled && _this.opts.autoOpen === 'imageEditor') {
          _this.openFileEditor(firstFile);
        }
      }
    });
    _this.initEvents = function () {
      // Modal open button
      if (_this.opts.trigger && !_this.opts.inline) {
        var showModalTrigger = (0, _findAllDOMElements.default)(_this.opts.trigger);
        if (showModalTrigger) {
          showModalTrigger.forEach(function (trigger) {
            return trigger.addEventListener('click', _this.openModal);
          });
        } else {
          _this.uppy.log('Dashboard modal trigger not found. Make sure `trigger` is set in Dashboard options, unless you are planning to call `dashboard.openModal()` method yourself', 'warning');
        }
      }
      _this.startListeningToResize();
      document.addEventListener('paste', _this.handlePasteOnBody);
      _this.uppy.on('plugin-added', _classPrivateFieldLooseBase(_this, _addSupportedPluginIfNoTarget)[_addSupportedPluginIfNoTarget]);
      _this.uppy.on('plugin-remove', _this.removeTarget);
      _this.uppy.on('file-added', _this.hideAllPanels);
      _this.uppy.on('dashboard:modal-closed', _this.hideAllPanels);
      _this.uppy.on('complete', _this.handleComplete);
      _this.uppy.on('files-added', _classPrivateFieldLooseBase(_this, _generateLargeThumbnailIfSingleFile)[_generateLargeThumbnailIfSingleFile]);
      _this.uppy.on('file-removed', _classPrivateFieldLooseBase(_this, _generateLargeThumbnailIfSingleFile)[_generateLargeThumbnailIfSingleFile]);

      // ___Why fire on capture?
      //    Because this.ifFocusedOnUppyRecently needs to change before onUpdate() fires.
      document.addEventListener('focus', _this.recordIfFocusedOnUppyRecently, true);
      document.addEventListener('click', _this.recordIfFocusedOnUppyRecently, true);
      if (_this.opts.inline) {
        _this.el.addEventListener('keydown', _this.handleKeyDownInInline);
      }
      if (_this.opts.autoOpen) {
        _this.uppy.on('files-added', _classPrivateFieldLooseBase(_this, _openFileEditorWhenFilesAdded)[_openFileEditorWhenFilesAdded]);
      }
    };
    _this.removeEvents = function () {
      var showModalTrigger = (0, _findAllDOMElements.default)(_this.opts.trigger);
      if (!_this.opts.inline && showModalTrigger) {
        showModalTrigger.forEach(function (trigger) {
          return trigger.removeEventListener('click', _this.openModal);
        });
      }
      _this.stopListeningToResize();
      document.removeEventListener('paste', _this.handlePasteOnBody);
      window.removeEventListener('popstate', _this.handlePopState, false);
      _this.uppy.off('plugin-added', _classPrivateFieldLooseBase(_this, _addSupportedPluginIfNoTarget)[_addSupportedPluginIfNoTarget]);
      _this.uppy.off('plugin-remove', _this.removeTarget);
      _this.uppy.off('file-added', _this.hideAllPanels);
      _this.uppy.off('dashboard:modal-closed', _this.hideAllPanels);
      _this.uppy.off('complete', _this.handleComplete);
      _this.uppy.off('files-added', _classPrivateFieldLooseBase(_this, _generateLargeThumbnailIfSingleFile)[_generateLargeThumbnailIfSingleFile]);
      _this.uppy.off('file-removed', _classPrivateFieldLooseBase(_this, _generateLargeThumbnailIfSingleFile)[_generateLargeThumbnailIfSingleFile]);
      document.removeEventListener('focus', _this.recordIfFocusedOnUppyRecently);
      document.removeEventListener('click', _this.recordIfFocusedOnUppyRecently);
      if (_this.opts.inline) {
        _this.el.removeEventListener('keydown', _this.handleKeyDownInInline);
      }
      if (_this.opts.autoOpen) {
        _this.uppy.off('files-added', _classPrivateFieldLooseBase(_this, _openFileEditorWhenFilesAdded)[_openFileEditorWhenFilesAdded]);
      }
    };
    _this.superFocusOnEachUpdate = function () {
      var isFocusInUppy = _this.el.contains(document.activeElement);
      // When focus is lost on the page (== focus is on body for most browsers, or focus is null for IE11)
      var isFocusNowhere = document.activeElement === document.body || document.activeElement === null;
      var isInformerHidden = _this.uppy.getState().info.length === 0;
      var isModal = !_this.opts.inline;
      if (
      // If update is connected to showing the Informer - let the screen reader calmly read it.
      isInformerHidden && (
      // If we are in a modal - always superfocus without concern for other elements
      // on the page (user is unlikely to want to interact with the rest of the page)
      isModal ||
      // If we are already inside of Uppy, or
      isFocusInUppy ||
      // If we are not focused on anything BUT we have already, at least once, focused on uppy
      //   1. We focus when isFocusNowhere, because when the element we were focused
      //      on disappears (e.g. an overlay), - focus gets lost. If user is typing
      //      something somewhere else on the page, - focus won't be 'nowhere'.
      //   2. We only focus when focus is nowhere AND this.ifFocusedOnUppyRecently,
      //      to avoid focus jumps if we do something else on the page.
      //   [Practical check] Without '&& this.ifFocusedOnUppyRecently', in Safari, in inline mode,
      //                     when file is uploading, - navigate via tab to the checkbox,
      //                     try to press space multiple times. Focus will jump to Uppy.
      isFocusNowhere && _this.ifFocusedOnUppyRecently)) {
        _this.superFocus(_this.el, _this.getPluginState().activeOverlayType);
      } else {
        _this.superFocus.cancel();
      }
    };
    _this.afterUpdate = function () {
      if (_this.opts.disabled && !_this.dashboardIsDisabled) {
        _this.disableInteractiveElements(true);
        return;
      }
      if (!_this.opts.disabled && _this.dashboardIsDisabled) {
        _this.disableInteractiveElements(false);
      }
      _this.superFocusOnEachUpdate();
    };
    _this.saveFileCard = function (meta, fileID) {
      _this.uppy.setFileMeta(fileID, meta);
      _this.toggleFileCard(false, fileID);
    };
    Object.defineProperty(_this, _attachRenderFunctionToTarget, {
      writable: true,
      value: function value(target) {
        var plugin = _this.uppy.getPlugin(target.id);
        return _objectSpread(_objectSpread({}, target), {}, {
          icon: plugin.icon || _this.opts.defaultPickerIcon,
          render: plugin.render
        });
      }
    });
    Object.defineProperty(_this, _isTargetSupported, {
      writable: true,
      value: function value(target) {
        var plugin = _this.uppy.getPlugin(target.id);
        // If the plugin does not provide a `supported` check, assume the plugin works everywhere.
        if (typeof plugin.isSupported !== 'function') {
          return true;
        }
        return plugin.isSupported();
      }
    });
    Object.defineProperty(_this, _getAcquirers, {
      writable: true,
      value: memoize(function (targets) {
        return targets.filter(function (target) {
          return target.type === 'acquirer' && _classPrivateFieldLooseBase(_this, _isTargetSupported)[_isTargetSupported](target);
        }).map(_classPrivateFieldLooseBase(_this, _attachRenderFunctionToTarget)[_attachRenderFunctionToTarget]);
      })
    });
    Object.defineProperty(_this, _getProgressIndicators, {
      writable: true,
      value: memoize(function (targets) {
        return targets.filter(function (target) {
          return target.type === 'progressindicator';
        }).map(_classPrivateFieldLooseBase(_this, _attachRenderFunctionToTarget)[_attachRenderFunctionToTarget]);
      })
    });
    Object.defineProperty(_this, _getEditors, {
      writable: true,
      value: memoize(function (targets) {
        return targets.filter(function (target) {
          return target.type === 'editor';
        }).map(_classPrivateFieldLooseBase(_this, _attachRenderFunctionToTarget)[_attachRenderFunctionToTarget]);
      })
    });
    _this.render = function (state) {
      var pluginState = _this.getPluginState();
      var files = state.files,
        capabilities = state.capabilities,
        allowNewUpload = state.allowNewUpload;
      var _this$uppy$getObjectO = _this.uppy.getObjectOfFilesPerState(),
        newFiles = _this$uppy$getObjectO.newFiles,
        uploadStartedFiles = _this$uppy$getObjectO.uploadStartedFiles,
        completeFiles = _this$uppy$getObjectO.completeFiles,
        erroredFiles = _this$uppy$getObjectO.erroredFiles,
        inProgressFiles = _this$uppy$getObjectO.inProgressFiles,
        inProgressNotPausedFiles = _this$uppy$getObjectO.inProgressNotPausedFiles,
        processingFiles = _this$uppy$getObjectO.processingFiles,
        isUploadStarted = _this$uppy$getObjectO.isUploadStarted,
        isAllComplete = _this$uppy$getObjectO.isAllComplete,
        isAllErrored = _this$uppy$getObjectO.isAllErrored,
        isAllPaused = _this$uppy$getObjectO.isAllPaused;
      var acquirers = _classPrivateFieldLooseBase(_this, _getAcquirers)[_getAcquirers](pluginState.targets);
      var progressindicators = _classPrivateFieldLooseBase(_this, _getProgressIndicators)[_getProgressIndicators](pluginState.targets);
      var editors = _classPrivateFieldLooseBase(_this, _getEditors)[_getEditors](pluginState.targets);
      var theme;
      if (_this.opts.theme === 'auto') {
        theme = capabilities.darkMode ? 'dark' : 'light';
      } else {
        theme = _this.opts.theme;
      }
      if (['files', 'folders', 'both'].indexOf(_this.opts.fileManagerSelectionType) < 0) {
        _this.opts.fileManagerSelectionType = 'files';
        // eslint-disable-next-line no-console
        console.warn("Unsupported option for \"fileManagerSelectionType\". Using default of \"".concat(_this.opts.fileManagerSelectionType, "\"."));
      }
      return (0, _Dashboard.default)({
        state: state,
        isHidden: pluginState.isHidden,
        files: files,
        newFiles: newFiles,
        uploadStartedFiles: uploadStartedFiles,
        completeFiles: completeFiles,
        erroredFiles: erroredFiles,
        inProgressFiles: inProgressFiles,
        inProgressNotPausedFiles: inProgressNotPausedFiles,
        processingFiles: processingFiles,
        isUploadStarted: isUploadStarted,
        isAllComplete: isAllComplete,
        isAllErrored: isAllErrored,
        isAllPaused: isAllPaused,
        totalFileCount: Object.keys(files).length,
        totalProgress: state.totalProgress,
        allowNewUpload: allowNewUpload,
        acquirers: acquirers,
        theme: theme,
        disabled: _this.opts.disabled,
        disableLocalFiles: _this.opts.disableLocalFiles,
        direction: _this.opts.direction,
        activePickerPanel: pluginState.activePickerPanel,
        showFileEditor: pluginState.showFileEditor,
        saveFileEditor: _this.saveFileEditor,
        closeFileEditor: _this.closeFileEditor,
        disableInteractiveElements: _this.disableInteractiveElements,
        animateOpenClose: _this.opts.animateOpenClose,
        isClosing: pluginState.isClosing,
        progressindicators: progressindicators,
        editors: editors,
        autoProceed: _this.uppy.opts.autoProceed,
        id: _this.id,
        closeModal: _this.requestCloseModal,
        handleClickOutside: _this.handleClickOutside,
        handleInputChange: _this.handleInputChange,
        handlePaste: _this.handlePaste,
        inline: _this.opts.inline,
        showPanel: _this.showPanel,
        hideAllPanels: _this.hideAllPanels,
        i18n: _this.i18n,
        i18nArray: _this.i18nArray,
        uppy: _this.uppy,
        note: _this.opts.note,
        recoveredState: state.recoveredState,
        metaFields: pluginState.metaFields,
        resumableUploads: capabilities.resumableUploads || false,
        individualCancellation: capabilities.individualCancellation,
        isMobileDevice: capabilities.isMobileDevice,
        fileCardFor: pluginState.fileCardFor,
        toggleFileCard: _this.toggleFileCard,
        toggleAddFilesPanel: _this.toggleAddFilesPanel,
        showAddFilesPanel: pluginState.showAddFilesPanel,
        saveFileCard: _this.saveFileCard,
        openFileEditor: _this.openFileEditor,
        canEditFile: _this.canEditFile,
        width: _this.opts.width,
        height: _this.opts.height,
        showLinkToFileUploadResult: _this.opts.showLinkToFileUploadResult,
        fileManagerSelectionType: _this.opts.fileManagerSelectionType,
        proudlyDisplayPoweredByUppy: _this.opts.proudlyDisplayPoweredByUppy,
        hideCancelButton: _this.opts.hideCancelButton,
        hideRetryButton: _this.opts.hideRetryButton,
        hidePauseResumeButton: _this.opts.hidePauseResumeButton,
        showRemoveButtonAfterComplete: _this.opts.showRemoveButtonAfterComplete,
        containerWidth: pluginState.containerWidth,
        containerHeight: pluginState.containerHeight,
        areInsidesReadyToBeVisible: pluginState.areInsidesReadyToBeVisible,
        isTargetDOMEl: _this.isTargetDOMEl,
        parentElement: _this.el,
        allowedFileTypes: _this.uppy.opts.restrictions.allowedFileTypes,
        maxNumberOfFiles: _this.uppy.opts.restrictions.maxNumberOfFiles,
        requiredMetaFields: _this.uppy.opts.restrictions.requiredMetaFields,
        showSelectedFiles: _this.opts.showSelectedFiles,
        showNativePhotoCameraButton: _this.opts.showNativePhotoCameraButton,
        showNativeVideoCameraButton: _this.opts.showNativeVideoCameraButton,
        nativeCameraFacingMode: _this.opts.nativeCameraFacingMode,
        singleFileFullScreen: _this.opts.singleFileFullScreen,
        handleCancelRestore: _this.handleCancelRestore,
        handleRequestThumbnail: _this.handleRequestThumbnail,
        handleCancelThumbnail: _this.handleCancelThumbnail,
        // drag props
        isDraggingOver: pluginState.isDraggingOver,
        handleDragOver: _this.handleDragOver,
        handleDragLeave: _this.handleDragLeave,
        handleDrop: _this.handleDrop
      });
    };
    Object.defineProperty(_this, _addSpecifiedPluginsFromOptions, {
      writable: true,
      value: function value() {
        var plugins = _this.opts.plugins || [];
        plugins.forEach(function (pluginID) {
          var plugin = _this.uppy.getPlugin(pluginID);
          if (plugin) {
            ;
            plugin.mount(_this, plugin);
          } else {
            _this.uppy.log("[Uppy] Dashboard could not find plugin '".concat(pluginID, "', make sure to uppy.use() the plugins you are specifying"), 'warning');
          }
        });
      }
    });
    Object.defineProperty(_this, _autoDiscoverPlugins, {
      writable: true,
      value: function value() {
        _this.uppy.iteratePlugins(_classPrivateFieldLooseBase(_this, _addSupportedPluginIfNoTarget)[_addSupportedPluginIfNoTarget]);
      }
    });
    Object.defineProperty(_this, _addSupportedPluginIfNoTarget, {
      writable: true,
      value: function value(plugin) {
        var _plugin$opts;
        // Only these types belong on the Dashboard,
        // we wouldn’t want to try and mount Compressor or Tus, for example.
        var typesAllowed = ['acquirer', 'editor'];
        if (plugin && !((_plugin$opts = plugin.opts) != null && _plugin$opts.target) && typesAllowed.includes(plugin.type)) {
          var pluginAlreadyAdded = _this.getPluginState().targets.some(function (installedPlugin) {
            return plugin.id === installedPlugin.id;
          });
          if (!pluginAlreadyAdded) {
            ;
            plugin.mount(_this, plugin);
          }
        }
      }
    });
    _this.install = function () {
      // Set default state for Dashboard
      _this.setPluginState({
        isHidden: true,
        fileCardFor: null,
        activeOverlayType: null,
        showAddFilesPanel: false,
        activePickerPanel: undefined,
        showFileEditor: false,
        metaFields: _this.opts.metaFields,
        targets: [],
        // We'll make them visible once .containerWidth is determined
        areInsidesReadyToBeVisible: false,
        isDraggingOver: false
      });
      var _this$opts5 = _this.opts,
        inline = _this$opts5.inline,
        closeAfterFinish = _this$opts5.closeAfterFinish;
      if (inline && closeAfterFinish) {
        throw new Error('[Dashboard] `closeAfterFinish: true` cannot be used on an inline Dashboard, because an inline Dashboard cannot be closed at all. Either set `inline: false`, or disable the `closeAfterFinish` option.');
      }
      var _this$uppy$opts = _this.uppy.opts,
        allowMultipleUploads = _this$uppy$opts.allowMultipleUploads,
        allowMultipleUploadBatches = _this$uppy$opts.allowMultipleUploadBatches;
      if ((allowMultipleUploads || allowMultipleUploadBatches) && closeAfterFinish) {
        _this.uppy.log('[Dashboard] When using `closeAfterFinish`, we recommended setting the `allowMultipleUploadBatches` option to `false` in the Uppy constructor. See https://uppy.io/docs/uppy/#allowMultipleUploads-true', 'warning');
      }
      var target = _this.opts.target;
      if (target) {
        _this.mount(target, _this);
      }
      if (!_this.opts.disableStatusBar) {
        _this.uppy.use(_statusBar.default, {
          id: "".concat(_this.id, ":StatusBar"),
          target: _this,
          hideUploadButton: _this.opts.hideUploadButton,
          hideRetryButton: _this.opts.hideRetryButton,
          hidePauseResumeButton: _this.opts.hidePauseResumeButton,
          hideCancelButton: _this.opts.hideCancelButton,
          showProgressDetails: _this.opts.showProgressDetails,
          hideAfterFinish: _this.opts.hideProgressAfterFinish,
          locale: _this.opts.locale,
          doneButtonHandler: _this.opts.doneButtonHandler
        });
      }
      if (!_this.opts.disableInformer) {
        _this.uppy.use(_informer.default, {
          id: "".concat(_this.id, ":Informer"),
          target: _this
        });
      }
      if (!_this.opts.disableThumbnailGenerator) {
        _this.uppy.use(_thumbnailGenerator.default, {
          id: "".concat(_this.id, ":ThumbnailGenerator"),
          thumbnailWidth: _this.opts.thumbnailWidth,
          thumbnailHeight: _this.opts.thumbnailHeight,
          thumbnailType: _this.opts.thumbnailType,
          waitForThumbnailsBeforeUpload: _this.opts.waitForThumbnailsBeforeUpload,
          // If we don't block on thumbnails, we can lazily generate them
          lazy: !_this.opts.waitForThumbnailsBeforeUpload
        });
      }

      // Dark Mode / theme
      _this.darkModeMediaQuery = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;
      var isDarkModeOnFromTheStart = _this.darkModeMediaQuery ? _this.darkModeMediaQuery.matches : false;
      _this.uppy.log("[Dashboard] Dark mode is ".concat(isDarkModeOnFromTheStart ? 'on' : 'off'));
      _this.setDarkModeCapability(isDarkModeOnFromTheStart);
      if (_this.opts.theme === 'auto') {
        var _this$darkModeMediaQu;
        (_this$darkModeMediaQu = _this.darkModeMediaQuery) == null || _this$darkModeMediaQu.addListener(_this.handleSystemDarkModeChange);
      }
      _classPrivateFieldLooseBase(_this, _addSpecifiedPluginsFromOptions)[_addSpecifiedPluginsFromOptions]();
      _classPrivateFieldLooseBase(_this, _autoDiscoverPlugins)[_autoDiscoverPlugins]();
      _this.initEvents();
    };
    _this.uninstall = function () {
      if (!_this.opts.disableInformer) {
        var informer = _this.uppy.getPlugin("".concat(_this.id, ":Informer"));
        // Checking if this plugin exists, in case it was removed by uppy-core
        // before the Dashboard was.
        if (informer) _this.uppy.removePlugin(informer);
      }
      if (!_this.opts.disableStatusBar) {
        var statusBar = _this.uppy.getPlugin("".concat(_this.id, ":StatusBar"));
        if (statusBar) _this.uppy.removePlugin(statusBar);
      }
      if (!_this.opts.disableThumbnailGenerator) {
        var thumbnail = _this.uppy.getPlugin("".concat(_this.id, ":ThumbnailGenerator"));
        if (thumbnail) _this.uppy.removePlugin(thumbnail);
      }
      var plugins = _this.opts.plugins || [];
      plugins.forEach(function (pluginID) {
        var plugin = _this.uppy.getPlugin(pluginID);
        if (plugin) plugin.unmount();
      });
      if (_this.opts.theme === 'auto') {
        var _this$darkModeMediaQu2;
        (_this$darkModeMediaQu2 = _this.darkModeMediaQuery) == null || _this$darkModeMediaQu2.removeListener(_this.handleSystemDarkModeChange);
      }
      if (_this.opts.disablePageScrollWhenModalOpen) {
        document.body.classList.remove('uppy-Dashboard-isFixed');
      }
      _this.unmount();
      _this.removeEvents();
    };
    _this.id = _this.opts.id || 'Dashboard';
    _this.title = 'Dashboard';
    _this.type = 'orchestrator';
    _this.defaultLocale = _locale.default;

    // Dynamic default options:
    if (_this.opts.doneButtonHandler === undefined) {
      // `null` means "do not display a Done button", while `undefined` means
      // "I want the default behavior". For this reason, we need to differentiate `null` and `undefined`.
      _this.opts.doneButtonHandler = function () {
        _this.uppy.clearUploadedFiles();
        _this.requestCloseModal();
      };
    }
    (_this$opts4$onRequest = (_this$opts4 = _this.opts).onRequestCloseModal) != null ? _this$opts4$onRequest : _this$opts4.onRequestCloseModal = function () {
      return _this.closeModal();
    };
    _this.i18nInit();
    return _this;
  }
  _inherits(Dashboard, _UIPlugin);
  return _createClass(Dashboard);
}(_core.UIPlugin);
Dashboard.VERSION = packageJson.version;